<template>
    <div>
        <template>
            <v-container>
                <v-row class="mt-4">
                    <v-col v-for="(card, i) in cards" :key="i" cols="12" sm="2" lg="1.5" xl="1" class="text-center pl-1 pr-1 pt-0">
                        <v-card>
                            <!-- <v-img :src="require(`${url_prefix}` + `${card.image}`)"></v-img> -->
                            <!-- <v-img :src="url_prefix + card.image"></v-img> -->
                            <img width="100%" :src="url_prefix + card.image" />
                            <v-card-text class="pt-0 pb-1 font-weight-bold">
                                ¥ {{ card.price }}
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <!-- <v-btn v-if="!pprint" color="primary" elevation="2" @click="print()" min-width="180">プリントする</v-btn> -->
        </template>
    </div>
</template>


<script>
export default {
    data: () => ({
        cards: [],
        url_prefix: "",
        pprint: false,
    }),
    methods: {
        print() {
            this.pprint = true
            // setTimeout(function() {
                // print()
                // console.log("okok")
            // }, 1500);
        }
    },
    mounted: function () {
        this.url_prefix = `${process.env.VUE_APP_API_ORIGIN}`
        this.cards = this.$route.params.choiced_cards
        setTimeout(function() {
            print()
        }, 1500);
    },
}
</script>


<style>
img{
    max-width: 100%;
    height: auto;
}
</style>
